<div>
    <div class="flex items-center">
        <h5>Incomplete Orders</h5>
        <i
            class="fa-regular fa-circle-question ml-1"
            nz-tooltip
            nzTooltipTitle="Customer Orders not in closed statuses (Completed, Refunded, Cancelled, Shipped)"
        ></i>
    </div>
    <nz-table [nzData]="orders" [nzShowPagination]="false" [nzPageSize]="5000">
        <thead>
            <tr>
                <th>Order #</th>
                <th>Created Date</th>
                <th>Last Update</th>
                <th>Total Price</th>
                <th>Status</th>
                <th>Assigned To</th>
                <th>Pharmacy</th>
            </tr>
        </thead>
        <tbody>
            <tr
                *ngFor="let order of orders"
                portals-emr-order-row
                [order]="order"
                [hiddenColumns]="hiddenColumns"
                [showDetails]="false"
            ></tr>
        </tbody>
    </nz-table>
</div>
